import { standard_api_result } from "@/api-lib/fl-mine/utils/others";
import { siteConfig } from "@/config/site";
import { clsx, type ClassValue } from "clsx";
import { formatDuration, intervalToDuration } from "date-fns";
import ms from "ms";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export const getTimestamp_ddHHmmssfff = () => {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
    const milliseconds = String(now.getMilliseconds()).padStart(3, "0");

    return `${day}${hours}${minutes}${seconds}${milliseconds}`;
};

export const fetch_standard_api_result = async (url: string, body: any) => {
    const response = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
    });

    const result_data: standard_api_result = (await response.json()) as unknown as standard_api_result;
    return result_data;
};

export const simpleFetch = async (url: string, body: any, bearer_token?: string) => {
    const headers = {
        "Content-Type": "application/json",
    };
    if (bearer_token) {
        headers["Authorization"] = `Bearer ${bearer_token}`;
    }
    const response = await fetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify(body),
    });

    let result_data: any = null;
    if (response.status == 204) {
        // no data
    } else if (response.ok) {
        // Check if status code is in the 200-299 range
        try {
            result_data = await response.json();
            // console.log("simpleFetch... got result_data!", result_data);
        } catch (error) {
            console.log("simpleFetch  ... result_data: ", result_data);
            console.error("Failed to parse JSON:", error);

            // Keep result_data as null
        }
    } else {
        console.error(
            new Date().toISOString().slice(11, 23).replace("T", " "),
            ` simpleFetch to url ${url}... response was not okay? `,
            response,
        );
    }

    return result_data;
};

export function formatDate(input: string | number): string {
    const date = new Date(input);
    return date.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
    });
}

// Utils from precedent.dev
export const timeAgo = (timestamp: Date, timeOnly?: boolean): string => {
    if (!timestamp) return "never";
    return `${ms(Date.now() - new Date(timestamp).getTime())}${timeOnly ? "" : " ago"}`;
};

// export async function fetcher<JSON = any>(input: RequestInfo, init?: RequestInit): Promise<JSON> {
//     const res = await fetch(input, init);

//     if (!res.ok) {
//         const json = await res.json();
//         if (json.error) {
//             const error = new Error(json.error) as Error & {
//                 status: number;
//             };
//             error.status = res.status;
//             throw error;
//         } else {
//             throw new Error("An unexpected error occurred");
//         }
//     }

//     return res.json();
// }

export function nFormatter(num: number, digits?: number) {
    if (!num) return "0";
    const lookup = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "K" },
        { value: 1e6, symbol: "M" },
        { value: 1e9, symbol: "G" },
        { value: 1e12, symbol: "T" },
        { value: 1e15, symbol: "P" },
        { value: 1e18, symbol: "E" },
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    const item = lookup
        .slice()
        .reverse()
        .find(function (item) {
            return num >= item.value;
        });
    return item ? (num / item.value).toFixed(digits || 1).replace(rx, "$1") + item.symbol : "0";
}

export function capitalize(str: string) {
    if (!str || typeof str !== "string") return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export const truncate = (str: string, length: number) => {
    if (!str || str.length <= length) return str;
    return `${str.slice(0, length)}...`;
};

export const getBlurDataURL = async (url: string | null) => {
    if (!url) {
        return "data:image/webp;base64,AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=";
    }

    if (url.startsWith("/_static/")) {
        url = `${siteConfig.url}${url}`;
    }

    try {
        const response = await fetch(`https://wsrv.nl/?url=${url}&w=50&h=50&blur=5`);
        const buffer = await response.arrayBuffer();
        const base64 = Buffer.from(buffer).toString("base64");

        return `data:image/png;base64,${base64}`;
    } catch (error) {
        return "data:image/webp;base64,AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=";
    }
};

export const placeholderBlurhash =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAoJJREFUWEfFl4lu4zAMRO3cx/9/au6reMaOdkxTTl0grQFCRoqaT+SQotq2bV9N8rRt28xms87m83l553eZ/9vr9Wpkz+ezkT0ej+6dv1X81AFw7M4FBACPVn2c1Z3zLgDeJwHgeLFYdAARYioAEAKJEG2WAjl3gCwNYymQQ9b7/V4spmIAwO6Wy2VnAMikBWlDURBELf8CuN1uHQSrPwMAHK5WqwFELQ01AIXdAa7XawfAb3p6AOwK5+v1ugAoEq4FRSFLgavfQ49jAGQpAE5wjgGCeRrGdBArwHOPcwFcLpcGU1X0IsBuN5tNgYhaiFFwHTiAwq8I+O5xfj6fOz38K+X/fYAdb7fbAgFAjIJ6Aav3AYlQ6nfnDoDz0+lUxNiLALvf7XaDNGQ6GANQBKR85V27B4D3QQRw7hGIYlQKWGM79hSweyCUe1blXhEAogfABwHAXAcqSYkxCtHLUK3XBajSc4Dj8dilAeiSAgD2+30BAEKV4GKcAuDqB4TdYwBgPQByCgApUBoE4EJUGvxUjF3Q69/zLw3g/HA45ABKgdIQu+JPIyDnisCfAxAFNFM0EFNQ64gfS0EUoQP8ighrZSjn3oziZEQpauyKbfjbZchHUL/3AS/Dd30gAkxuRACgfO+EWQW8qwI1o+wseNuKcQiESjALvwNoMI0TcRzD4lFcPYwIM+JTF5x6HOs8yI7jeB5oKhpMRFH9UwaSCDB2Jmg4rc6E2TT0biIaG0rQhNqyhpHBcayTTSXH6vcDL7/sdqRK8LkwTsU499E8vRcAojHcZ4AxABdilgrp4lsXk8oVqgwh7+6H3phqd8J0Kk4vbx/+sZqCD/vNLya/5dT9fAH8g1WdNGgwbQAAAABJRU5ErkJggg==";

export const humanReadableTimestamp = (the_date?: Date | null) => {
    if (!the_date) {
        the_date = new Date();
    }
    const now = the_date;

    const timestampMilliseconds = now.getTime(); // Get milliseconds since epoch

    const dateString = now.toLocaleDateString("en-US", {
        // Format date
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    });

    const timeString = now.toLocaleTimeString("en-US", {
        // Format time
        hour12: false, // Use 24-hour format
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        // fractionalSecondDigits: 3, // Include milliseconds
    });

    const formattedTimestamp = `${dateString} ${timeString}`;
    return formattedTimestamp;
};

// Escape / Unescape some HTML characters
// ( From: https://stackoverflow.com/questions/18749591/encode-html-entities-in-javascript/39243641#39243641 )
// spell-checker: disable
export const unescapeHTML = (function () {
    const htmlEntities: any = Object.freeze({
        nbsp: " ",
        cent: "¢",
        pound: "£",
        yen: "¥",
        euro: "€",
        copy: "©",
        reg: "®",
        lt: "<",
        gt: ">",
        quot: '"',
        amp: "&",
        apos: "'",
    });
    return function (str?: string): string {
        return ((str || "") + "").replace(/&([^;]+);/g, function (entity: string, entityCode: string): string {
            let match;
            if (entityCode in htmlEntities) {
                return htmlEntities[entityCode];
            } else if ((match = entityCode.match(/^#x([\da-fA-F]+)$/))) {
                // eslint-disable-line no-cond-assign
                return String.fromCharCode(parseInt(match[1], 16));
            } else if ((match = entityCode.match(/^#(\d+)$/))) {
                // eslint-disable-line no-cond-assign
                return String.fromCharCode(~~match[1]);
            } else {
                return entity;
            }
        });
    };
})();

export const escapeHTML = (function () {
    const escapeChars = {
        "¢": "cent",
        "£": "pound",
        "¥": "yen",
        "€": "euro",
        "©": "copy",
        "®": "reg",
        "<": "lt",
        ">": "gt",
        '"': "quot",
        "&": "amp",
        "'": "#39",
    };
    let regexString = "[";
    for (const key in escapeChars) {
        regexString += key;
    }
    regexString += "]";
    const regex = new RegExp(regexString, "g");
    return function escapeHTML(str: string): string {
        return str.replace(regex, function (m) {
            return "&" + (escapeChars as any)[m] + ";";
        });
    };
})();

export function formatSeconds(seconds) {
    const duration = intervalToDuration({ start: 0, end: seconds * 1000 });

    return formatDuration(duration, { format: ["minutes", "seconds"] });
}
